import Animation from './Animation.vue';
import AvatarConversation from './AvatarConversation.vue';
import BlackBox from './BlackBox.vue';
import Carousel from './Carousel.vue';
import ClickReveal from './ClickReveal.vue';
import Consequence from './Consequence.vue';
import DragSort from './DragSort.vue';
import Full from './Full.vue';
import Grid from './Grid.vue';
import IdealTextQuestion from './IdealTextQuestion.vue';
import Input from './Input.vue';
import Menu from './Menu.vue';
import MetaAnalysis from './MetaAnalysis.vue';
import Multiplier from './Multiplier.vue';
import OpenResponseQuestion from './OpenResponseQuestion.vue';
import OpenResponseQuestionAI from './OpenResponseQuestionAI.vue';
import OpenResponseQuestionMultiAI from './OpenResponseQuestionMultiAI.vue';
import OpenResponseQuestionWithFeedback from './OpenResponseQuestionWithFeedback.vue';
import Question from './Question.vue';
import RandomEvent from './RandomEvent.vue';
import Standard from './Standard.vue';
import Stop from './Stop.vue';
import Summary from './Summary.vue';
import VideoFull from './VideoFull.vue';

export default {
    Standard,
    Full,
    VideoFull,
    BlackBox,
    Summary,
    Question,
    IdealTextQuestion,
    OpenResponseQuestion,
    OpenResponseQuestionWithFeedback,
    OpenResponseQuestionAI,
    Stop,
    RandomEvent,
    Grid,
    Consequence,
    Multiplier,
    DragSort,
    Input,
    MetaAnalysis,
    ClickReveal,
    OpenResponseQuestionMultiAI,
    Menu,
    Carousel,
    Animation,
    AvatarConversation,
};
